<template>
    <div>
        <page-header
            :title="$t('pages.admin.video.stats.title')"
            icon-class="mdi mdi-frequently-asked-questions"
        />
        <div class="row">
            <div class="col-md-12 mb-3">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-5">
                                <h5 class="card-title">
                                    {{
                                        $t(
                                            "pages.admin.video.stats.video_favorites"
                                        )
                                    }}
                                </h5>
                                <div v-if="videoTotalFavorited">
                                    Total Favorited :
                                    {{ videoTotalFavorited.favorited }}
                                </div>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="mb-3">
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            favoritesChartMode === 'daily'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="favoritesChartMode = 'daily'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.daily"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            favoritesChartMode === 'weekly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="favoritesChartMode = 'weekly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.weekly"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            favoritesChartMode === 'monthly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="favoritesChartMode = 'monthly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.monthly"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            favoritesChartMode === 'yearly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="favoritesChartMode = 'yearly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.yearly"
                                            )
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <favorites-chart
                            :mode="favoritesChartMode"
                            :data="videoFavorites"
                        ></favorites-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-5">
                                <h5 class="card-title">
                                    {{
                                        $t(
                                            "pages.admin.video.stats.video_stats"
                                        )
                                    }}
                                </h5>
                                <div>
                                    Total Completed :
                                    {{ videoViewsStats.completed }}
                                </div>
                                <div>
                                    Total Viewed : {{ videoViewsStats.views }}
                                </div>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="mb-3">
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            viewsChartMode === 'daily'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="viewsChartMode = 'daily'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.daily"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            viewsChartMode === 'weekly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="viewsChartMode = 'weekly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.weekly"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            viewsChartMode === 'monthly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="viewsChartMode = 'monthly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.monthly"
                                            )
                                        }}
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        :class="[
                                            viewsChartMode === 'yearly'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]"
                                        @click="viewsChartMode = 'yearly'"
                                    >
                                        {{
                                            $t(
                                                "pages.locker.my_aform.stats_types.yearly"
                                            )
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <view-chart
                            :mode="viewsChartMode"
                            :data="videoStats"
                        ></view-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminVideoRepository from "../../../repositories/Admin/AdminVideoRepository";
import ViewChart from "../../../components/Includes/Charts/VideoStats/ViewChart";
import FavoritesChart from "../../../components/Includes/Charts/VideoStats/FavoritesChart";
import PageHeader from "../../../components/Includes/PageHeader";

export default {
    name: "VideoStats",
    components: { ViewChart, PageHeader, FavoritesChart },

    data: () => ({
        videoStats: [],
        videoViewsStats: {},
        videoFavorites: [],
        videoTotalFavorited: null,
        viewsChartMode: "daily",
        favoritesChartMode: "daily"
    }),
    watch: {
        viewsChartMode: function(val) {
            this.getVideoStats();
        },
        favoritesChartMode: function(val) {
            this.getVideoFavorites();
        }
    },
    mounted() {
        this.getVideoStats();
        this.getTotalVideoViews();
        this.getVideoFavorites();
        this.getVideoTotalFavorited();
        this.scrollToTop();
    },
    methods: {
        getVideoStats() {
            AdminVideoRepository.getVideoStats(
                this.$route.params.video,
                this.viewsChartMode
            ).then(res => (this.videoStats = res.data));
        },
        getVideoFavorites() {
            AdminVideoRepository.getVideoFavorites(
                this.$route.params.video,
                this.favoritesChartMode
            ).then(res => (this.videoFavorites = res.data));
        },
        getVideoTotalFavorited() {
            AdminVideoRepository.getVideoTotalFavorited(
                this.$route.params.video
            ).then(res => (this.videoTotalFavorited = res.data));
        },
        getTotalVideoViews() {
            AdminVideoRepository.getTotalVideoViews(
                this.$route.params.video
            ).then(res => (this.videoViewsStats = res.data));
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    }
};
</script>

<style></style>
